import { GridLocaleText } from '@mui/x-data-grid';

export const localizedTextsMap = {
  noRowsLabel: 'Sem registros',
  toolbarExport: 'Exportar',
  toolbarExportCSV: 'Exportar em CSV',
  toolbarExportPrint: 'Imprimir',
  columnMenuUnsort: 'Não classificado',
  columnMenuSortAsc: 'Ordem crescente',
  columnMenuSortDesc: 'Ordem decrescente',
  columnMenuFilter: 'Filtro',
  columnMenuHideColumn: 'Ocultar',
  columnMenuShowColumns: 'Mostrar colunas',
  columnsPanelHideAllButton: 'Ocultar todos',
  columnsPanelShowAllButton: 'Exibir todos',
  columnsPanelTextFieldLabel: 'Pesquisar coluna',
  columnsPanelTextFieldPlaceholder: 'Nome da coluna',
  checkboxSelectionHeaderName: 'Checkbox',
  footerRowSelected: (counter) => `${counter} linha(s) selecionada(s)`,
  columnHeaderSortIconLabel: 'Ordernar',
  MuiTablePagination: {
    labelRowsPerPage: 'Linhas por página',
    labelDisplayedRows: ({ from, to, count }) => `${from} - ${to} de ${count}`,
  },
} as Partial<GridLocaleText>;
